import installationInstructions from './installationInstructions';

const pepPlugContent = {
  installationInstructions
}

export { pepPlugContent };
